export default function linearProgress({ variables }) {
    return {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: "10px",
                    borderRadius: variables.border_radius_pill,
                    backgroundColor: variables.surface_track,
                    "& > .MuiLinearProgress-bar": {
                        borderRadius: variables.border_radius_pill,
                    },
                    "&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar": {
                        backgroundColor: variables.interactive_selected,
                    },
                    "&.MuiLinearProgress-colorSuccess > .MuiLinearProgress-bar": {
                        backgroundColor: variables.feedback_success,
                    },
                    "&.MuiLinearProgress-colorWarning > .MuiLinearProgress-bar": {
                        backgroundColor: variables.feedback_warning,
                    },
                    "&.MuiLinearProgress-colorError > .MuiLinearProgress-bar": {
                        backgroundColor: variables.feedback_danger,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=linearProgress.js.map